import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgFill } from '@chegg-ui/svg-icon';
import { DirectionalSvgIcon } from '../../styles';
var Caret = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DirectionalSvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M.08 11.093c-.162.408-.073.877.227 1.19L21.259 34.1c.197.205.463.32.741.32.278 0 .544-.115.74-.32l20.953-21.818c.3-.312.39-.781.227-1.189a1.048 1.048 0 0 0-.968-.673H1.048c-.424 0-.806.266-.968.673Z"
  }));
});
Caret.displayName = 'Caret';
Caret.defaultProps = {
  'aria-label': 'Caret'
};
export default Caret;